import { FieldPath } from "./fieldPath";

const allFieldsAreDirty = (dirtyFields, nameFields: Array<string>) => {
    for (const name of nameFields) {
        const fieldPath = name.split(".");
        let dirtyField = dirtyFields;

        for (const path of fieldPath) {
            dirtyField = dirtyField[path];

            if (!dirtyField) return false;
        }
    }

    return true;
};
const allFieldsAreValid = (errorFields, nameFields: Array<string>) => {
    for (const name of nameFields) {
        const fieldPath = name.split(".");
        let errorField = errorFields;

        for (const path of fieldPath) {
            errorField = errorField[path];
            if (!errorField) break;
        }

        if (errorField) return false;
    }

    return true;
};

export const isSubFormValid = <FormType>(
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    dirtyFields,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    errors,
    requiredFields: FieldPath<FormType>[],
    optionalFields: FieldPath<FormType>[] = [],
): boolean => {
    return (
        allFieldsAreDirty(dirtyFields, requiredFields) &&
        allFieldsAreValid(errors, requiredFields.concat(optionalFields))
    );
};
